import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface TAssignedDepositData {
  removable: number
  feeId: number
  description: string
  date: string
  amountDue: number
  feeStatus: string
  allowPartial: boolean
  createdByType: number
  note: string | null
  formSubmissionId: string | null
  formData: string | null
  menuItemId: number
  familyMaxId: number
  variablePricingEnabled: boolean
  disabled: boolean
  enrollmentId: number | null
  onHoldAllowedToPurchase: number | null
  orderItemTypeId: number | null
}

// GET /ajax/student/{student_account_id}/assigned_deposits
export const assignedDeposits = async (studentAccountId: number) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/assigned_deposits'
  )
  return Util.Obj.keysToCamel(response.data.items) as TAssignedDepositData[]
}
